module.exports = __webpack_public_path__ + "static/3-1670404f7846707aeb4d6fe05a9a8f5f.jpg";